import React, { forwardRef, useImperativeHandle } from "react";
import { Row, Col } from "antd";
import DatePickerField from "../blueplanitUtils/DatePickerField";
import { AntdButton, TimePickerField } from "../blueplanitUtils/InputField";
import { InputField, SelectInput } from "../blueplanitUtils/InputField";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getEmployeesListThunk } from "../Slices/Thunk/getemployeelist";
 
import dayjs from "dayjs";
 
const AttendanceFilter = forwardRef(({ onFilter }, ref) => {
    const [filters, setFilters] = React.useState({
        date: null,
        shift: "",
        status: "",
        ecode: "",
        employeeName: "", // ✅ FIX
        // name: "",
        inTime: null,
        outTime: null,
        workDur: "",
        ot: "",
    });
 
    const dispatch = useDispatch();
 
    const details = useSelector((state) => state.employee.AllEmployees || []);
 
  const employeesOptions =
    details.map((emp) => ({
      label: `${emp.firstname} ${emp.lastname}`,
      value: `${emp.firstname} ${emp.lastname}`,
    })) || [];
 
 
    // useEffect(() => {
    //     dispatch(getEmployeesListThunk());
    // }, [dispatch]);
 
 
    useImperativeHandle(ref, () => ({
        resetForm() {
            setFilters({
                date: null,
                shift: "",
                status: "",
                ecode: "",
                employeeName: "",   // ✅ correct key
                inTime: null,
                outTime: null,
                workDur: "",
                ot: "",
            });
            onFilter({});
        },
    }));
 
    const handleChange = (field, value) => {
        const newFilters = { ...filters, [field]: value };
        setFilters(newFilters);
    };
 
    return (
        <div className="card" style={{ padding: "15px", marginBottom: "20px" }}>
            <Row gutter={16}>
                <Col span={4}>
                    <DatePickerField
                        label="Date"
                        value={filters.date ? dayjs(filters.date, "YYYY-MM-DD") : null}
                        onChange={(val) => handleChange("date", val ? val.format("YYYY-MM-DD") : null)}
                    />
                </Col>
 
                <Col span={4}>
                    <SelectInput
                        label="Shift"
                        placeholder="Shift"
                        value={filters.shift}
                        onChange={(val) => handleChange("shift", val)}
                        style={{ width: "100%" }}
                        options={[
                            { label: "NoShift", value: "NoShift" },
                            { label: "General", value: "General" },
                        ]}
                    />
                </Col>
 
                <Col span={4}>
                    <SelectInput
                        label="Status"
                        placeholder="Status"
                        value={filters.status}
                        onChange={(val) => handleChange("status", val)}
                        style={{ width: "100%" }}
                        options={[
                            { label: "Present", value: "Present" },
                            { label: "Absent", value: "Absent" },
                            { label: "WeeklyOff", value: "WeeklyOff" },
                            { label: "½Present", value: "½Present" }
                        ]}
                    />
                </Col>
 
                {/* EMPLOYEE CODE */}
                <Col span={4}>
                    <InputField
                        label="Employee Code"
                        placeholder="Employee Code"
                        value={filters.ecode}
                        onChange={(e) => handleChange("ecode", e.target.value)}
                    />
                </Col>
 
                <Col span={4}>
                    <SelectInput
                        label="Employee Name"
                        options={employeesOptions}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        value={filters.employeeName || ""}
                        onChange={(value) => handleChange("employeeName", value)}
                        style={{ width: "100%" }}
                        allowClear
                    />
                </Col>
 
                <Col span={4} style={{ marginTop: "5px" }}>
                    <DatePickerField
                        label="In Date & Time"
                        showTime
                        inputReadOnly
                        format="DD/MM/YYYY HH:mm"
                        value={
                            filters.inTime
                                ? dayjs(filters.inTime, "YYYY-MM-DD HH:mm")
                                : null
                        }
                        onChange={(date) =>
                            handleChange(
                                "inTime",
                                date ? date.format("YYYY-MM-DD HH:mm") : null
                            )
                        }
                        allowClear
                        style={{ width: "100%" }}
                    />
                </Col>
 
                <Col span={4} style={{ marginTop: "5px" }}>
                    <DatePickerField
                        label="Out Date & Time"
                        showTime
                        inputReadOnly
                        format="DD/MM/YYYY HH:mm"
                        value={
                            filters.outTime
                                ? dayjs(filters.outTime, "YYYY-MM-DD HH:mm")
                                : null
                        }
                        onChange={(date) =>
                            handleChange(
                                "outTime",
                                date ? date.format("YYYY-MM-DD HH:mm") : null
                            )
                        }
                        allowClear
                        style={{ width: "100%" }}
                    />
                </Col>
 
                <Col span={4}>
                    <TimePickerField
                        label="Work Duration"
                        format="HH:mm"
                        value={filters.workDur ? dayjs(filters.workDur, "HH:mm") : null}
                        onChange={(val) => handleChange("workDur", val ? val.format("HH:mm") : null)}
                    />
                </Col>
 
                <Col span={4}>
                    <TimePickerField
                        label="OT"
                        format="HH:mm"
                        value={filters.ot ? dayjs(filters.ot, "HH:mm") : null}
                        onChange={(val) => handleChange("ot", val ? val.format("HH:mm") : null)}
                    />
                </Col>
            </Row>
            <Row align="middle" style={{ marginTop: "12px" }}>
                <Col span={12} style={{ display: "flex", alignItems: "center" }}>
                    {/* <Tooltip title="Sync Now">
                        <FontAwesomeIcon
                            icon={faSync}
                            style={{
                                fontSize: "22px",
                                color: "#1890ff",
                                cursor: "pointer",
                            }}
                        // onClick={handleRefresh}
                        />
                    </Tooltip> */}
                </Col>
 
                <Col
                    span={12}
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                    }}
                >
                    <AntdButton
                        onClick={() =>
                            onFilter({
                                ecode: filters.ecode,
                                employeeName: filters.employeeName,
                                status: filters.status,
                                shift: filters.shift,
                                date: filters.date,
                                inTime: filters.inTime,
                                outTime: filters.outTime,
                                workDur: filters.workDur,
                                ot: filters.ot,
                            })
                        }
                        label="Search"
                        style={{
                            padding: "6px 14px",
                            background: "green",
                            color: "#fff",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    />
 
                    <AntdButton
                        onClick={() => ref.current?.resetForm()}
                        label="Clear"
                        style={{
                            padding: "6px 14px",
                            background: "#007bff",
                            color: "#fff",
                            fontWeight: 500,
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    />
                </Col>
            </Row>
 
 
        </div>
    );
 
});
 
export default AttendanceFilter;
 
 